// @ts-nocheck
import React from 'react';

/**
 * KpiTile — labeled number with optional unit, delta pill, and a tiny inline
 * sparkline. Pass `sparkline` as an array of numbers; the component renders
 * an SVG line in the bottom-right corner that follows the value trend.
 */
const KpiTile = ({
  label,
  value,
  unit,
  delta,
  deltaTone = 'up',
  icon: Icon,
  sparkline,
  meta,
  className = '',
}) => (
  <div className={`mov-kpi-tile ${className}`}>
    <div className="mov-mono flex justify-between items-center mb-2.5 text-[10.5px] uppercase tracking-[0.12em] text-mov-ink-mute">
      {label}
      {Icon && (
        <span className="mov-kpi-icon-chip grid place-items-center">
          <Icon size={12} />
        </span>
      )}
    </div>
    <div className="mov-display flex items-baseline gap-1 text-[34px] leading-none tracking-[-0.01em] text-mov-ink">
      {value}
      {unit && <span className="text-[14px] text-mov-ink-mute font-medium font-[inherit]">{unit}</span>}
    </div>
    {(delta || meta) && (
      <div className="flex items-center gap-2 mt-2.5 text-[12px] text-mov-ink-soft">
        {delta && <DeltaPill tone={deltaTone}>{delta}</DeltaPill>}
        {meta && <span>{meta}</span>}
      </div>
    )}
    {sparkline && <Sparkline values={sparkline} tone={deltaTone} />}
  </div>
);

const DeltaPill = ({ tone, children }) => {
  const cls = tone === 'down' ? 'mov-delta-down' : tone === 'flat' ? 'mov-delta-flat' : 'mov-delta-up';
  const arrow = tone === 'down' ? '▼ ' : tone === 'flat' ? '· ' : '▲ ';
  return (
    <span className={`mov-mono mov-delta ${cls}`}>
      {arrow}
      {children}
    </span>
  );
};

const Sparkline = ({ values, tone }) => {
  if (!values || values.length < 2) return null;
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const w = 80; const h = 30;
  const step = w / (values.length - 1);
  const points = values.map((v, i) => `${(i * step).toFixed(1)},${(h - ((v - min) / range) * h).toFixed(1)}`).join(' L');
  const stroke = tone === 'down' ? 'var(--mov-danger)' : 'var(--mov-accent)';
  return (
    <svg
      className="mov-kpi-sparkline"
      width={w} height={h} viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none"
    >
      <path d={`M${points}`} fill="none" stroke={stroke} strokeWidth="1.5" />
    </svg>
  );
};

export default KpiTile;
